import { render } from "./NotificacionesBell.vue?vue&type=template&id=3aaa9065"
import script from "./NotificacionesBell.vue?vue&type=script&lang=js"
export * from "./NotificacionesBell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__